"use strict";

var _defineProperty2 = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _slicedToArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _assertThisInitialized = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var defaultResizeStyles = {
  root: {
    position: 'absolute'
  },
  resizer: {
    position: 'absolute',
    width: '1px',
    height: '100%',
    left: '100px',
    cursor: 'ew-resize',
    border: '0.1px solid rgba(224, 224, 224, 1)'
  }
};
function getParentOffsetLeft(tableEl) {
  var ii = 0;
  var parentOffsetLeft = 0;
  var offsetParent = tableEl.offsetParent;
  while (offsetParent) {
    parentOffsetLeft += offsetParent.offsetLeft || 0;
    offsetParent = offsetParent.offsetParent;
    ii++;
    if (ii > 1000) {
      console.warn('Table nested within 1000 divs. Maybe an error.');
      break;
    }
  }
  return parentOffsetLeft;
}
var TableResize = /*#__PURE__*/function (_react$default$Compon) {
  _inherits(TableResize, _react$default$Compon);
  function TableResize() {
    var _this;
    _classCallCheck(this, TableResize);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TableResize).apply(this, arguments));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      resizeCoords: {},
      priorPosition: {},
      tableWidth: '100%',
      tableHeight: '100%'
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleResize", function () {
      if (window.innerWidth !== _this.windowWidth) {
        _this.windowWidth = window.innerWidth;
        _this.setDividers();
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setCellRefs", function (cellsRef, tableRef) {
      _this.cellsRef = cellsRef;
      _this.tableRef = tableRef;
      _this.setDividers();
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "setDividers", function () {
      var tableEl = _this.tableRef;
      var _tableEl$getBoundingC = tableEl.getBoundingClientRect(),
        tableWidth = _tableEl$getBoundingC.width,
        tableHeight = _tableEl$getBoundingC.height;
      var resizeCoords = _this.state.resizeCoords;
      var parentOffsetLeft = getParentOffsetLeft(tableEl);
      var finalCells = Object.entries(_this.cellsRef);
      finalCells.pop();
      finalCells.forEach(function (_ref, idx) {
        var _ref5 = _slicedToArray(_ref, 2),
          key = _ref5[0],
          item = _ref5[1];
        if (!item) return;
        var elRect = item.getBoundingClientRect();
        var left = elRect.left;
        left = (left || 0) - parentOffsetLeft;
        var elStyle = window.getComputedStyle(item, null);
        resizeCoords[key] = {
          left: left + item.offsetWidth
        };
      });
      _this.setState({
        tableWidth: tableWidth,
        tableHeight: tableHeight,
        resizeCoords: resizeCoords
      }, _this.updateWidths);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "updateWidths", function () {
      var lastPosition = 0;
      var _this$state = _this.state,
        resizeCoords = _this$state.resizeCoords,
        tableWidth = _this$state.tableWidth;
      Object.entries(resizeCoords).forEach(function (_ref2) {
        var _ref6 = _slicedToArray(_ref2, 2),
          key = _ref6[0],
          item = _ref6[1];
        var newWidth = Number((item.left - lastPosition) / tableWidth * 100);

        /*
          Using .toFixed(2) causes the columns to jitter when resized. On all browsers I (patrojk) have tested,
          a width with a floating point decimal works fine. It's unclear to me why the numbers were being rouned.
          However, I'm putting in an undocumented escape hatch to use toFixed in case the change introduces a bug.
          The below code will be removed in a later release if no problems with non-rounded widths are reported.
        */
        if (typeof _this.props.resizableColumns === 'object' && _this.props.resizableColumns.roundWidthPercentages) {
          newWidth = newWidth.toFixed(2);
        }
        lastPosition = item.left;
        var thCell = _this.cellsRef[key];
        if (thCell) thCell.style.width = "".concat(newWidth, "%");
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onResizeStart", function (id, e) {
      var tableEl = _this.tableRef;
      var originalWidth = tableEl.style.width;
      tableEl.style.width = '1px';
      var finalCells = Object.entries(_this.cellsRef);
      finalCells.forEach(function (_ref3, idx) {
        var _ref7 = _slicedToArray(_ref3, 2),
          key = _ref7[0],
          item = _ref7[1];
        var elRect = item.getBoundingClientRect();
        _this.minWidths[idx] = elRect.width;
      });
      tableEl.style.width = originalWidth;
      _this.setState({
        isResize: true,
        id: id
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onResizeMove", function (id, e) {
      var _this$state2 = _this.state,
        isResize = _this$state2.isResize,
        resizeCoords = _this$state2.resizeCoords;
      var fixedMinWidth1 = _this.minWidths[id];
      var fixedMinWidth2 = _this.minWidths[parseInt(id, 10) + 1] || _this.minWidths[id];
      var idNumber = parseInt(id, 10);
      var finalCells = Object.entries(_this.cellsRef);
      var tableEl = _this.tableRef;
      var _tableEl$getBoundingC2 = tableEl.getBoundingClientRect(),
        tableWidth = _tableEl$getBoundingC2.width,
        tableHeight = _tableEl$getBoundingC2.height;
      var selectableRows = _this.props.options.selectableRows;
      var parentOffsetLeft = getParentOffsetLeft(tableEl);
      if (isResize) {
        var leftPos = e.clientX - parentOffsetLeft;
        var handleMoveRightmostBoundary = function handleMoveRightmostBoundary(leftPos, tableWidth, fixedMinWidth) {
          if (leftPos > tableWidth - fixedMinWidth) {
            return tableWidth - fixedMinWidth;
          }
          return leftPos;
        };
        var handleMoveLeftmostBoundary = function handleMoveLeftmostBoundary(leftPos, fixedMinWidth) {
          if (leftPos < fixedMinWidth) {
            return fixedMinWidth;
          }
          return leftPos;
        };
        var handleMoveRight = function handleMoveRight(leftPos, resizeCoords, id, fixedMinWidth) {
          if (leftPos > resizeCoords[id + 1].left - fixedMinWidth) {
            return resizeCoords[id + 1].left - fixedMinWidth;
          }
          return leftPos;
        };
        var handleMoveLeft = function handleMoveLeft(leftPos, resizeCoords, id, fixedMinWidth) {
          if (leftPos < resizeCoords[id - 1].left + fixedMinWidth) {
            return resizeCoords[id - 1].left + fixedMinWidth;
          }
          return leftPos;
        };
        var isFirstColumn = function isFirstColumn(selectableRows, id) {
          return selectableRows !== 'none' && id === 0 || selectableRows === 'none' && id === 1;
        };
        var isLastColumn = function isLastColumn(id, finalCells) {
          return id === finalCells.length - 2;
        };
        if (isFirstColumn(selectableRows, idNumber) && isLastColumn(idNumber, finalCells)) {
          leftPos = handleMoveLeftmostBoundary(leftPos, fixedMinWidth1);
          leftPos = handleMoveRightmostBoundary(leftPos, tableWidth, fixedMinWidth2);
        } else if (!isFirstColumn(selectableRows, idNumber) && isLastColumn(idNumber, finalCells)) {
          leftPos = handleMoveRightmostBoundary(leftPos, tableWidth, fixedMinWidth2);
          leftPos = handleMoveLeft(leftPos, resizeCoords, idNumber, fixedMinWidth1);
        } else if (isFirstColumn(selectableRows, idNumber) && !isLastColumn(idNumber, finalCells)) {
          leftPos = handleMoveLeftmostBoundary(leftPos, fixedMinWidth1);
          leftPos = handleMoveRight(leftPos, resizeCoords, idNumber, fixedMinWidth2);
        } else if (!isFirstColumn(selectableRows, idNumber) && !isLastColumn(idNumber, finalCells)) {
          leftPos = handleMoveLeft(leftPos, resizeCoords, idNumber, fixedMinWidth1);
          leftPos = handleMoveRight(leftPos, resizeCoords, idNumber, fixedMinWidth2);
        }
        var curCoord = _objectSpread(_objectSpread({}, resizeCoords[id]), {}, {
          left: leftPos
        });
        var newResizeCoords = _objectSpread(_objectSpread({}, resizeCoords), {}, _defineProperty2({}, id, curCoord));
        _this.setState({
          resizeCoords: newResizeCoords,
          tableHeight: tableHeight
        }, _this.updateWidths);
      }
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onResizeEnd", function (id, e) {
      _this.setState({
        isResize: false,
        id: null
      });
    });
    return _this;
  }
  _createClass(TableResize, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.minWidths = [];
      this.windowWidth = null;
      this.props.setResizeable(this.setCellRefs);
      this.props.updateDividers(function () {
        return _this2.setState({
          updateCoords: true
        }, function () {
          return _this2.updateWidths;
        });
      });
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var classes = this.props.classes;
      var _this$state3 = this.state,
        id = _this$state3.id,
        isResize = _this$state3.isResize,
        resizeCoords = _this$state3.resizeCoords,
        tableWidth = _this$state3.tableWidth,
        tableHeight = _this$state3.tableHeight;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.root,
        style: {
          width: tableWidth
        }
      }, Object.entries(resizeCoords).map(function (_ref4) {
        var _ref8 = _slicedToArray(_ref4, 2),
          key = _ref8[0],
          val = _ref8[1];
        return /*#__PURE__*/_react.default.createElement("div", {
          "aria-hidden": "true",
          key: key,
          onMouseMove: _this3.onResizeMove.bind(null, key),
          onMouseUp: _this3.onResizeEnd.bind(null, key),
          style: {
            width: isResize && id == key ? tableWidth : 'auto',
            position: 'absolute',
            height: tableHeight - 2,
            cursor: 'ew-resize',
            zIndex: 1000
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          "aria-hidden": "true",
          onMouseDown: _this3.onResizeStart.bind(null, key),
          className: classes.resizer,
          style: {
            left: val.left
          }
        }));
      }));
    }
  }]);
  return TableResize;
}(_react.default.Component);
_defineProperty(TableResize, "propTypes", {
  /** Extend the style applied to components */
  classes: _propTypes.default.object
});
var _default = (0, _styles.withStyles)(defaultResizeStyles, {
  name: 'MUIDataTableResize'
})(TableResize);
exports.default = _default;